function normalizer(array) {
  const result = {}
  for (let index = 0; index < array.length; index++) {
    const element = array[index];
    if(element.id){
      result[element.id] = element
    }
  }
  return result
}

export { normalizer }